import { ActionReducer } from '@ngrx/store';
import { ErrorAction, errorAdd, errorRemove } from '../core/reducers/loading-error.reducer';
import * as userProfileActions from '../core/actions/user-profile.actions';

type Actions = userProfileActions.Actions;

/**
 * Loading error reducer manages errors during server communication.
 */
export const loadingError: ActionReducer<any> = (state: any = {}, action: Actions) => {

    switch (action.type) {
        case userProfileActions.LOAD_ERROR:
            return errorAdd(state, new ErrorAction(userProfileActions.LOAD_ERROR, action.payload));
        case userProfileActions.LOAD_SUCCESS:
            return errorRemove(state, new ErrorAction(userProfileActions.LOAD_ERROR));

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/reducers/loading-error.reducer.ts